<template>
  <div class="login-wrapper">
    <login @login="onLogin" @provider="onProvider"></login>
  </div>
</template>
<script>
import Login from "../../components/Auth/Login";
export default {
  components: {
    Login
  },
  setup(props, context) {
    const store = context.root.$store

    function onLogin(e) {
      if (e.isValid) {
        store.dispatch('authLogin', { email: e.credentials.email, password: e.credentials.password})
      }
    }

    function onProvider(provider) {
      store.dispatch('authProvider', { provider: provider })
    }
    return {
      onLogin,
      onProvider
    }
  }
}
</script>
<style lang="scss">
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  z-index: 10;
  position: relative;
}
</style>